import { Skeleton } from '@/components/ui/skeleton'

export function SkeletonCard() {
  return (
    <div className="flex flex-col space-y-3 min-w-[38%] md:min-w-[24%] lg:min-w-[unset] lg:max-w-[12rem]">
      <Skeleton className="rounded-lg py-4 px-5 h-[105px]" />
    </div>
  )
}
